import React from "react";
import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { CONTACT } from "@/data/site";

// Sticky mobile action bar (call + devis), visible while scrolling
export default function StickyCall() {
  return (
    <div
      data-testid="sticky-call-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 flex border-t border-white/10 bg-ink/95 backdrop-blur-xl"
    >
      <a
        href={`tel:${CONTACT.phoneTel}`}
        data-testid="sticky-call-btn"
        className="flex-1 flex items-center justify-center gap-2 py-3.5 text-sm font-bold text-white"
      >
        <Phone size={18} className="text-aqua" /> Appeler
      </a>
      <Link
        to="/contact"
        data-testid="sticky-devis-btn"
        className="flex-1 flex items-center justify-center gap-2 py-3.5 text-sm font-bold text-white bg-flame"
      >
        <FileText size={18} /> Devis gratuit
      </Link>
    </div>
  );
}
